import '@/utils/set-server-time';
import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
import { rem, initReport, user } from '@tencent/ppd-base-libs';
import { install as I18nVuePlugin } from '@/i18n';
import { addBiToESIntercept, aegis } from '@tencent/wphk-base-report';
import { plugin } from '@tencent/fit-bi-sdk';
import { createPinia, PiniaVuePlugin } from 'pinia';
import MtaConfigGlobal from '@/mta-config-global';
import './assets/tailwind.css';
// 登录态处理
import '@/utils/login';
import { PAGE_TITLE } from './config';
import { initMtnBiReport, mtnBiReport } from '@tencent/wphk-components-mtn-bi-report';
import { handleBigFont } from '@tencent/wphk-base-utils';
import { REPORT_WHITE_LIST } from './config/bi-to-es-white-list';

// 处理大字体闪动
handleBigFont();

// 设置页面标题
document.title = PAGE_TITLE;

// pinia初始化
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// 测速上报初始化，id传入项目英文名称，如：pay-center、discount-center
aegis.init({ id: process.env.VUE_APP_PKGNAME });

// 添加全局i18n函数
Vue.use(I18nVuePlugin);

// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);

// bi工具初始化代码，请注意使用 bi-cli 生成 mta-config-global.ts 后，引入到项目中，并在main.ts中初始化
Vue.use(plugin, {
  ...MtaConfigGlobal,
  route: router,
  isUseBeacon: true,
  postReportUrl: `https://hq-tracking-pay.qq.com/report/minipro/v2?r2=${MtaConfigGlobal.cid}`,
  beforeReport: item => ({
    ...item,
    params: { ...item.params, fuin: user.getUin() || 'empty@wx.hkg' },
  }),
});

addBiToESIntercept(REPORT_WHITE_LIST);

// 初始化上报
initReport({
  router,
  // @ts-ignore
  appEnv: process.env.VUE_APP_ENV,
  // @ts-ignore
  business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
  isReportPageStayedTime: true, // 是否上报页面停留时间
  sentry: {
    dsn: 'https://c05e48ef096e447b8b601663d1e542d0@report.url.cn/sentry/3929',
    // webpack变异全局变量
    release: process.env.VUE_APP_SENTRY_VERSION || 'default',
  },
  bi: {
    reportNeedLogin: true,
  },
  appVersion: process.env.VUE_APP_SENTRY_VERSION,
}, Vue);

// MTN上报初始化
initMtnBiReport({
  // 登陆后再上报
  needLogin: true,
  channel: process.env.VUE_APP_PKGNAME,
});

// 开启rem布局
rem();

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-subscribe'];

new Vue({
  router,
  render: h => h(App),
  pinia,
}).$mount('#app');

aegis.reportTime('main_ready');

/**
 * 从端外中转页跳转过来，并接收到MTN，此时需要进行物料追踪上报
 */
mtnBiReport();
